class LmSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sliderContainer = this.querySelector(".lm-slider__slider-container");
    if (this.sliderContainer) this.sliderContainer.scrollLeft = 80;

    let isDown = false;
    let startX;
    let scrollLeft;

    this.sliderContainer.addEventListener("mousedown", (e) => {
      if (this.isDesktop) return;
      isDown = true;
      this.sliderContainer.classList.add("active");
      startX = e.pageX - this.sliderContainer.offsetLeft;
      scrollLeft = this.sliderContainer.scrollLeft;
      console.log("mousedown:", { isDown, startX, scrollLeft });
      e.preventDefault(); // Prevent default behavior
    });

    this.sliderContainer.addEventListener("mouseleave", () => {
      if (this.isDesktop) return;
      isDown = false;
      this.sliderContainer.classList.remove("active");
      console.log("mouseleave:", { isDown });
    });

    this.sliderContainer.addEventListener("mouseup", () => {
      if (this.isDesktop) return;
      isDown = false;
      this.sliderContainer.classList.remove("active");
      console.log("mouseup:", { isDown });
    });

    this.sliderContainer.addEventListener("mousemove", (e) => {
      if (!isDown || this.isDesktop) return;
      e.preventDefault();
      const x = e.pageX - this.sliderContainer.offsetLeft;
      const walk = x - startX; // Adjust the scroll speed multiplier as needed
      this.sliderContainer.scrollLeft = scrollLeft - walk;
      console.log("mousemove:", {
        x,
        walk,
        scrollLeft: this.sliderContainer.scrollLeft,
      });
    });
  }

  isDesktop() {
    return window.innerWidth > 1000;
  }
}

customElements.define("lm-slider", LmSlider);
